import IntervalRecurrencePatternBaseType from 'owa-service/lib/contract/IntervalRecurrencePatternBaseType';
import RecurrenceType from 'owa-service/lib/contract/RecurrenceType';
import { isYearlyRecurrence } from 'owa-recurrence-utils/lib/checkRecurrenceTypes';

export default function getRecurrenceInterval(recurrence: RecurrenceType): number {
    // YearlyRecurrence doesn't contain Interval property, so return default 1
    if (!recurrence || isYearlyRecurrence(recurrence)) {
        return 1;
    }
    let recurrencePattern = recurrence.RecurrencePattern as IntervalRecurrencePatternBaseType;
    return recurrencePattern.Interval;
}
